import networkAutomation from "public/pocCloud/network-automation.png";

export const INTRO_CONSTANTS = {
  title: "Effortless Automation for Complex Network Environments ",
  description: [
    "OneMind’s Network Automation solution simplifies how you manage that complexity by automating multi-vendor device provisioning, configuration updates, and compliance enforcement across your infrastructure.",
    "Whether you're maintaining a campus network or scaling data center operations, our automation framework ensures reduced downtime, improved security posture, and consistent change control.",
  ],
  points: [
    "Faster network changes without human error.",
    "Stronger compliance posture with full audit trails.",
    "Reduced mean time to recovery (MTTR) for misconfigurations.",
    "Consistent deployment from branch offices to core networks.",
  ],
  image: networkAutomation,
};
